import createUsersGroup from './actions/createUsersGroup';
import getUsersGroup from './actions/getUsersGroup';
import removeUsersGroup from './actions/removeUsersGroup';
import updateUsersGroup from './actions/updateUsersGroup';
import usersGroupsList from './actions/usersGroupsList';
import getUsersGroups from './getters/getUsersGroups';
import uploadUsersGroups from './mutations/uploadUsersGroups';

const actions = {
    usersGroupsList,
    getUsersGroup,
    createUsersGroup,
    updateUsersGroup,
    removeUsersGroup
};

const mutations = {
    uploadUsersGroups
};

const getters = {
    getUsersGroups
};

export default { actions, mutations, getters };
